import moment from 'moment'
import { prettyUrlParam } from '../../../helpers'

const adminTable = (component) => {
  return {
    id: component.id,
    order: component.order,
    name: component.name,
    knowledgecheck_id: component.knowledgecheck_id,
    status: component.is_active ? 'active' : 'inactive',
    topics: component.topics,
    created: moment(component.created_at).unix(),
    updated: moment(component.updated_at).unix()
  }
}

const clientTable = (component) => {
  return {
    id: component.id,
    name: component.name,
    order: component.order,
    description: component.description,
    mainImage: component.main_image,
    knowledgecheck_id: component.knowledgecheck_id
  }
}

export default {
  set (state) {
    let set = []
    for (const view in state.views) {
      const data = state.views[view].ids.map((id) => state.views[view].index[id])
      set = set.concat(data)
    }

    return set
  },

  view (state) {
    return (view) => {
      const isClient = view === state._clientView
      const data = state.views[view].ids.map((id) => state.views[view].index[id])
      if (isClient) {
        return data.map(clientTable)
      }
      return data.map(adminTable)
    }
  },

  exists (state, getters) {
    return (id) => {
      const component = getters.set.find((component) => {
        return component.id === id
      })
      return typeof(component) !== 'undefined'
    }
  },

  byPrettyUrlName (state, getters) {
    return (prettyName) => {
      return getters.set.find((component) => {
        return prettyUrlParam(component.name) === prettyName
      })
    }
  },

  forClientByID (state, getters) {
    return (id) => {
      const component = getters.set.find((component) => {
        return component.id === id
      })

      return clientTable(component)
    }
  },

  unsavedChanges(state) {
    const current = state.current
    const formFields = state.forms.update.fields
    let unsaved = false

    if (!current) {
      return unsaved
    }

    // replacing the main image with a new upload
    if (formFields.image !== null || formFields.imageName) {
      unsaved = true
    }

    // replacing the main image from the library
    if (formFields.imageID !== null && current.main_image === null) {
      unsaved = true
    }

    if (
      formFields.imageID !== null &&
      current.main_image !== null &&
      formFields.imageID !== current.main_image.id
    ) {
      unsaved = true
    }

    if (formFields.name && current.name !== formFields.name) {
      unsaved = true
    }

    if (formFields.description && current.description !== formFields.description) {
      unsaved = true
    }

    if (formFields.active !== null && Number(current.is_active) !== Number(formFields.active)) {
      unsaved = true
    }

    return unsaved
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/components/getters.js